module.exports = __webpack_public_path__ + "static/media/81ZKNYBwYlL._AC_SL1500_.3ed265f0.jpg";